import './TooltipPacklistShipToContent.css'
import Config from '../../../../config/Config'

export const TooltipPacklistShipToContent = ({ data }) => {
  const shipmentShipToAddress = data?.shipmentShipToAddress
  const serviceLevelCode = data?.serviceLevelCode
  let pickupPoint = shipmentShipToAddress
    ? shipmentShipToAddress?.shipToDropoffPointIdentifier
    : data?.shipToDropoffPointIdentifier
  let addressline3 = shipmentShipToAddress?.addressLine3Text || data?.addressLine3Text || ''
  if (Config.MAP_ADDRESSLINE_3_TO_PUP_IDENTIFIER && serviceLevelCode === 'CPG') {
    pickupPoint = shipmentShipToAddress
      ? shipmentShipToAddress?.addressLine3Text
      : data?.addressLine3Text
    addressline3 = ''
  }

  return (
    <table className="tooltip-shipto-content">
      <thead>
        <th colSpan={2}>
          <td>Ship To Details</td>
        </th>
      </thead>
      <tbody>
        {(shipmentShipToAddress?.shipToName2 || data?.shipToName2) && (
          <tr>
            <td>Ship To Name 2</td>
            <td>
              {shipmentShipToAddress ? shipmentShipToAddress?.shipToName2 : data?.shipToName2}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.addressLine1Text || data?.addressLine1Text) && (
          <tr>
            <td>Address</td>
            <td>
              {shipmentShipToAddress
                ? `${shipmentShipToAddress?.addressLine1Text ?? ''} ${
                    shipmentShipToAddress?.addressLine2Text ?? ''
                  } ${addressline3} ${shipmentShipToAddress?.addressLine4Text ?? ''}`
                : `${data?.addressLine1Text} ${data?.addressLine2Text ?? ''} ${addressline3} ${
                    data?.addressLine4Text ?? ''
                  }`}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.cityName || data?.cityName) && (
          <tr>
            <td>City Name</td>
            <td>{shipmentShipToAddress ? shipmentShipToAddress?.cityName : data?.cityName}</td>
          </tr>
        )}
        {(shipmentShipToAddress?.zipCode || data?.zipCode) && (
          <tr>
            <td>Zip Code</td>
            <td>{shipmentShipToAddress ? shipmentShipToAddress?.zipCode : data?.zipCode}</td>
          </tr>
        )}
        {(shipmentShipToAddress?.provinceStateRegionCode || data?.provinceStateRegionCode) && (
          <tr>
            <td>Province State Region Code</td>
            <td>
              {shipmentShipToAddress
                ? shipmentShipToAddress?.provinceStateRegionCode
                : data?.provinceStateRegionCode}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.countryCode || data?.countryCode) && (
          <tr>
            <td>Ship To Country</td>
            <td>
              {shipmentShipToAddress ? shipmentShipToAddress?.countryCode : data?.countryCode}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.languageCode || data?.languageCode) && (
          <tr>
            <td>Language Code</td>
            <td>
              {shipmentShipToAddress ? shipmentShipToAddress?.languageCode : data?.languageCode}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.emailAddressText || data?.emailAddressText) && (
          <tr>
            <td>Email Address</td>
            <td>
              {shipmentShipToAddress
                ? shipmentShipToAddress?.emailAddressText
                : data?.emailAddressText}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.phoneNumber || data?.phoneNumber) && (
          <tr>
            <td>Phone Number</td>
            <td>
              {shipmentShipToAddress ? shipmentShipToAddress?.phoneNumber : data?.phoneNumber}
            </td>
          </tr>
        )}
        {(shipmentShipToAddress?.countyName || data?.countyName) && (
          <tr>
            <td>County Name</td>
            <td>{shipmentShipToAddress ? shipmentShipToAddress?.countyName : data?.countyName}</td>
          </tr>
        )}
        {pickupPoint && (
          <tr>
            <td>Pickup Point</td>
            <td>{pickupPoint}</td>
          </tr>
        )}
        {(shipmentShipToAddress?.thirdPartyDepartmentLocationText ||
          data?.thirdPartyDepartmentLocationText) && (
          <tr>
            <td>Third Party Department Location</td>
            <td>
              {shipmentShipToAddress
                ? shipmentShipToAddress?.thirdPartyDepartmentLocationText
                : data?.thirdPartyDepartmentLocationText}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TooltipPacklistShipToContent
